import "../../styles/app_static_sass/footer.scss";

const Footer = () => {
	return (
		<div className="footer">
			<h1 className="footer__copyright">
				&copy; Cristina Soare, Holly Mathieson & Louise Osborne, 2023
			</h1>
		</div>
	);
};

export default Footer;
